<template>
  <v-container grid-list-lg fluid>
    <v-layout column>
      <v-flex>
        <v-card outlined class="mt-0">
          <v-toolbar dense flat :color="$style.purchase.titlebar">
            <v-toolbar-title> Edit Template <span># {{ Subscription.id }}</span></v-toolbar-title>
            <v-spacer> </v-spacer>
            <v-row justify="end">
              <v-col class="shrink">
                <v-btn color="pink" small :loading="loadingUpdateBtn" :disabled="disabled"
                  @click="updateSubscription">{{
                    subscriptionTotal | currency
                  }} Update</v-btn>
              </v-col>

              <v-col class="shrink">
                <v-btn small text @click.stop.prevent="cancel">Cancel</v-btn>
              </v-col>
            </v-row>
          </v-toolbar>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 md3>
                <v-select outlined rounded dense :items="['Donor', 'Parent']" v-model="templateType"
                  label="Select Type"></v-select>
              </v-flex>
              <v-flex xs12 md9 v-if="templateType === 'Donor'">
                <DonorsAutoComplete v-model="selectedCustomer" label="Select Donor" @reset="$emit('reset')"
                  :initValue="initValue" :errorMessages="selectCustomerError" />
              </v-flex>
              <v-flex xs12 md9 v-else>
                <ParentAutoComplete label="Select Parent" v-model="selectedCustomer" @reset="$emit('reset')"
                  :initValue="initValue" :errorMessages="selectCustomerError" />
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex shrink md2>
                <v-select hide-details outlined dense :items="['Monthly', 'Yearly']" v-model="interval"
                  label="Interval"></v-select>
              </v-flex>
              <v-flex v-if="interval === 'Monthly'" shrink>
                <v-layout row align-center>
                  <v-flex shrink>
                    on
                  </v-flex>
                  <v-flex shrink>
                    <v-select hide-details outlined dense item-text="name" :items="Days" return-object
                      v-model="selectedDay" label="Day"></v-select>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex v-else shrink>
                <v-layout row align-center>
                  <v-flex shrink>
                    every
                  </v-flex>
                  <v-flex shrink>
                    <v-select hide-details outlined dense item-text="name" return-object :items="Month"
                      v-model="selectedMonth" label="Month"></v-select>
                  </v-flex>
                  <v-flex shrink>
                    <v-select hide-details outlined dense item-text="name" :items="Days" return-object
                      v-model="selectedDay" label="Day"></v-select>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex shrink>
                <v-layout row align-center>
                  <v-flex shrink>
                    <DateSelector label="Start Date" v-model="startingDate" :initValue="Subscription.startingDate"
                      :notClearable="true" />
                  </v-flex>
                  <v-flex shrink>
                    <v-select hide-details outlined dense :items="['Forever', 'By', 'Cycle']" v-model="end"
                      label="End"></v-select>
                  </v-flex>
                  <v-flex shrink v-if="end === 'By'">
                    <DateSelector label="End Date" :initValue="endDateInit" v-model="endDate" :notClearable="true" />
                  </v-flex>
                  <v-flex shrink v-if="end === 'Cycle'">
                    <v-text-field type="number" outlined dense hide-details v-model="cycle"
                      label="Cycle"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <p class="mt-3 black--text">Invoice will be created <span class="font-weight-bold">{{ interval }}</span> on
              the <span class="font-weight-bold" v-if="selectedDay.value !== 'last'">{{ selectedDay.name }}</span> <span
                v-else class="font-weight-bold">{{ selectedDay.name }} Day </span>
              of every <span v-if="selectedMonth" class="font-weight-bold">{{ selectedMonth.name }}</span>
              <span v-else>month,</span> starting <span class="font-weight-bold">{{ Subscription.startingDate |
                moment("L")
                }}</span> <span v-if="end !== 'Forever'"> and will cancel on
                <span class="font-weight-bold">{{ endDate | moment("L") }}</span>.</span>
              <span v-else class="font-weight-bold red--text">until cancel.</span> First Invoice will be created
              on <span class="font-weight-bold">{{ Subscription.nextInvoiceDate | moment("L") }}</span>
            </p>
            <v-layout row wrap align-center>
              <v-flex>
                <v-checkbox
                    label="Cash Collect"
                    hide-details
                    outlined
                    dense
                    v-model="cashCollect"
                  ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout row wrap align-center>
              <v-flex v-if="isCustomer">
                <v-btn color="success" @click="addCurrentStudents">add current students</v-btn>


                <!-- <v-checkbox label="Select Current Students" v-model="Subscription.studentSub"></v-checkbox> -->
              </v-flex>
              <v-flex shrink>
                <v-select dense outlined hide-details="" :items="MerchantAccount" v-model="selectedMerchant"
                  return-object item-text="name" label="Select Default Account"></v-select>
              </v-flex>

              <!-- {{ Subscription.DefaultDonationCategoryId }} -->
              <!-- <v-flex>
              <v-select item-text="last4" return-object v-model="selectedCard" :loading="loadingCard" outlined dense
                hide-details :items="cards" label="Payment Method">
                <template slot="item" slot-scope="{ item }">
                  <span>{{ item.last4 }}</span>
                  <v-spacer></v-spacer>
                  <span class="text-capitalize">{{ item.payment_method_type
                  }}</span>
                </template>
</v-select>
</v-flex> -->
            </v-layout>



          </v-card-text>


        </v-card>
      </v-flex>
      <v-flex>
        <ProductSearchBar @submit="addRow" :customerID="selectedCustomer" />
      </v-flex>
      <v-flex>
        <Cart />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import studentService from "@/modules/Student/service.js";
import productService from "@/modules/Product/service.js";
import subscriptionService from "@/modules/Subscription/service.js";
import ProductSearchBar from "@/modules/Subscription/components/ProductSearchBar";
import Cart from "@/modules/Subscription/components/Cart";
import DateSelector from "@/components/DateSelector";
import DonorsAutoComplete from "@/modules/Donors/components/AutoComplete.vue";
import ParentAutoComplete from "@/modules/Customer/components/AutoComplete.vue";
import donationCategoryService from "@/modules/DonationCategory/service.js";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "create-subscription-invoice",
  data() {
    return {
      selectedMerchant: null,
      MerchantAccount: [],
      studentSub: false,
      loadingCard: false,
      isCustomer: false,
      cashCollect: false,
      cards: [],
      autoSelectedType: "donor",
      order: null,
      loadingUpdateBtn: false,
      selectCustomerError: [],
      initValue: null,
      selectedMonth: { name: 'January', value: 1 },
      end: 'Forever',
      selectedDay: { name: '1st', value: 1 },
      interval: 'Monthly',
      templateType: 'Parent',
      editDialog: false,
      setCustomer: null,
      endDate: null,
      endDateInit: new Date().toISOString(),
      cycle: null,
      startingDate: new Date().toISOString(),
      Months: [
        { name: 'January', value: 1 },
        { name: 'February', value: 2 },
        { name: 'March', value: 3 },
        { name: 'April', value: 4 },
        { name: 'May', value: 5 },
        { name: 'June', value: 6 },
        { name: 'July', value: 7 },
        { name: 'August', value: 8 },
        { name: 'September', value: 9 },
        { name: 'October', value: 10 },
        { name: 'November', value: 11 },
        { name: 'December', value: 12 }
      ],
      Days: [
        { name: '1st', value: 1 },
        { name: '2nd', value: 2 },
        { name: '3rd', value: 3 },
        { name: '4th', value: 4 },
        { name: '5th', value: 5 },
        { name: '6th', value: 6 },
        { name: '7th', value: 7 },
        { name: '8th', value: 8 },
        { name: '9th', value: 9 },
        { name: '10th', value: 10 },
        { name: '11th', value: 11 },
        { name: '12th', value: 12 },
        { name: '13th', value: 13 },
        { name: '14th', value: 14 },
        { name: '15th', value: 15 },
        { name: '16th', value: 16 },
        { name: '17th', value: 17 },
        { name: '18th', value: 18 },
        { name: '19th', value: 19 },
        { name: '20th', value: 20 },
        { name: '21st', value: 21 },
        { name: '22nd', value: 22 },
        { name: '23rd', value: 23 },
        { name: '24th', value: 24 },
        { name: '25th', value: 25 },
        { name: '26th', value: 26 },
        { name: '27th', value: 27 },
        { name: '28th', value: 28 },
        { name: 'Last', value: 'last' },
      ]
    };
  },
  components: {
    Cart,
    DonorsAutoComplete,
    DateSelector,
    ParentAutoComplete,
    ProductSearchBar,
  },
  watch: {
    cycle() {
      this.setEndDate()
    },
    startingDate() {
      this.setEndDate()
    },
    selectedDay() {
      this.setEndDate()
    },
    selectedMonth() {
      this.setEndDate()
    },
    interval: {
      handler(val) {
        if (val === 'Monthly') {
          this.selectedMonth = null
          this.setEndDate()
        } else {
          this.selectedMonth = { name: 'January', value: 1 }
          this.setEndDate()
        }
      },
      deep: true, // Watch for changes within the object
      immediate: true // This option triggers the watch immediately
    },
    end(val) {
      console.log('end', val)
      this.setEndDate()
    }
  },
  async created() {
    if (!this.Subscription.id) {
      await this.loadData();
      this.getDonationCategoryList()


    }

  },
  computed: {
    ...mapGetters("global", [
      "currentBusiness",
    ]),
    ...mapGetters("subscription", [
      "Subscription",
      "SubscriptionDetails",
      "subscriptionTotal",
      "getSelectedCustomer",
      "getSelectedCampaign",
    ]),
    selectedCampaign: {
      get: function () {
        return this.getSelectedCampaign;
      },
      set: function (val) {
        this.SetSelectedCampaign(val);
      },
    },
    disabled() {
      if (!this.subscriptionTotal && !this.Subscription.studentSub)
        return true
      return false;
    },
    selectedCustomer: {
      get: function () {
        return this.getSelectedCustomer;
      },
      set: function (val) {
        this.SetSelectedCustomer(val);
      },
    },
  },
  methods: {
    ...mapActions("subscription", [
      "AddSubscriptionDetail",
      "ResetSubscriptionDetail",
      "ResetSubscription",
      "SetEditSubscriptionId",
      "loadSubscription",
      "SetSelectedCustomer",
      "SetSelectedCampaign",
    ]),



    getDonationCategoryList() {
      return donationCategoryService.getAll().then((response) => {
        //console.log('response merchant', response)
        this.MerchantAccount = response.data;
        this.MerchantAccount.map(row => {
          if (row.id === this.currentBusiness.DefaultSchoolFeeId) {
            this.selectedMerchant = row

          }
        })
        if (this.Subscription.DefaultDonationCategoryId) {
          this.MerchantAccount.map(row => {
          if (this.Subscription.DefaultDonationCategoryId === row.id) {
            console.log('found it', row)
            this.selectedMerchant = row
          }
        })
        }
        

      });
    },
    async addCurrentStudents() {
      // console.log('this.selectedCustomer', this.selectedCustomer)
      // console.log('this.currentBusiness', this.currentBusiness)
      let students = (await studentService.getAll({ CustomerId: this.selectedCustomer.id })).data
      // console.log('students', this.students)

      let product = null
      const business = this.currentBusiness

      if (business && business.metadata && business.metadata.defaultProduct && business.metadata.defaultProduct.id) {
        product = (await productService.getById(business.metadata.defaultProduct.id)).data
        console.log('product', product)
        if (!product) {
          return false;
        }
      } else {
        return false;
      }


      if (students.length !== 0) {
        // this.ResetSubscriptionDetail()
        for (var i = 0; i < students.length; i++) {
          let student = students[i]
          console.log('student', student.ClassStudents.length)
          if (student.ClassStudents.length) {
            student.ClassStudents.map(row => {
              let studentRow = {
                name: `${product.name} - Parent Pay: ${row.parentPay} (${student.fullName})`,
                price: row.parentPay + row.charity,
                qty: 1,
                parentPay: row.parentPay,
                BusinessId: business.id,
                ProductId: product.id,
                StudentId: student.id,
                ClassRoomId: row.ClassRoomId,
                ClassId: row.Class.id,
                description: row.Class.name,
              }
              this.AddSubscriptionDetail(studentRow)
            })
          }
        }
      }
    },
    setEndDate() {
      if (this.interval === "Monthly") {
        if (this.end === 'By') {
          const endDate = this.$moment(this.startingDate).add(1, 'months');
          this.endDateInit = endDate.toISOString()
          this.Subscription.endDate = this.endDate
          this.Subscription.recurringForever = false
          this.nextInvoiceDate()
        } else if (this.end === 'Cycle') {
          this.Subscription.recurringForever = false
          const startingDate = this.$moment(this.startingDate).add(1, 'months')
          const endDate = startingDate.clone().add(this.cycle, 'months');
          this.endDateInit = endDate.toISOString()
          this.endDate = this.endDateInit
          this.Subscription.endDate = this.endDate
          this.nextInvoiceDate()
        } else {
          this.Subscription.recurringForever = true;
          this.endDateInit = null
          this.endDate = this.endDateInit
          this.Subscription.endDate = null
          this.nextInvoiceDate()
        }
      } else {
        if (this.end === 'By') {
          const endDate = this.$moment(this.startingDate).add(1, 'years');
          this.endDateInit = endDate.toISOString();
          this.endDate = this.endDateInit;
          this.Subscription.endDate = this.endDate;
          this.Subscription.recurringForever = false;
          this.nextInvoiceDate();
        } else if (this.end === 'Cycle') {
          const startingDate = this.$moment(this.startingDate);
          const endDate = startingDate.clone().add(this.cycle, 'years');

          this.endDateInit = endDate.toISOString();
          this.endDate = this.endDateInit;
          this.Subscription.endDate = this.endDate;
          this.Subscription.recurringForever = false;
          this.nextInvoiceDate();
        } else {
          this.endDateInit = null;
          this.endDate = this.endDateInit;
          this.Subscription.endDate = null;
          this.Subscription.recurringForever = true;
          this.nextInvoiceDate();
        }
      }
    },
    nextInvoiceDate() {
      const startingDate = this.$moment(this.startingDate);
      let nextInvoiceDate = null
      if (this.interval === "Yearly") {
        nextInvoiceDate = startingDate.clone().date(this.selectedDay.value).month(this.selectedMonth.value);
      } else {
        nextInvoiceDate = startingDate.clone().date(this.selectedDay.value)
      }
      if (nextInvoiceDate.isSameOrBefore(startingDate)) {
        if (this.interval === "Yearly") {
          nextInvoiceDate.add(1, 'years');
        } else {
          nextInvoiceDate.add(1, 'months');
        }
      }

      const currentDate = this.$moment();
      if (nextInvoiceDate.isBefore(currentDate)) {
        if (this.interval === "Monthly") {
          nextInvoiceDate.month(currentDate.month());
          if (nextInvoiceDate.isBefore(currentDate)) {
            nextInvoiceDate.add(1, 'months');
          }
        } else if (this.interval === "Yearly") {
          nextInvoiceDate.year(currentDate.year() + 1);
        }
      }

      if (this.selectedDay.value === 'last') {
        nextInvoiceDate.endOf('month');
      }
      this.Subscription.endDate = this.endDate
      const dateNoTime = nextInvoiceDate.startOf('day')
      const isoString = dateNoTime.format('YYYY-MM-DD');
      this.Subscription.nextInvoiceDate = isoString
    },
    cancel() {
      if (this.SubscriptionDetails.length > 0) {
        this.$swal({
          title: "Are you sure?",
          text: "You want to cancel this subscription",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#B71C1C",
          cancelButtonColor: "#43A047",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }).then((result) => {
          if (result.value) {
            this.ResetSubscription();
            this.$router.go(-1);
          }
        });
      } else {
        this.ResetSubscription();
        this.$router.go(-1);
      }
    },
    loadData() {
      const { id } = this.$route.params;
      return subscriptionService.getById(id).then((response) => {
        console.log("responseresponseresponse", response);
        this.initCamp = response.data.Campaign;
        this.initDonor = response.data.Donor;
        this.initInvoice = response.data;
        this.cashCollect = response.data.cashCollect;
        this.loadSubscription(response.data);
        this.SetEditSubscriptionId(response.data.id);


        if (response.data.DonorId) {
          this.isCustomer = false
          this.initValue = response.data.Donor;
          this.selectedCustomer = response.data.Donor
          this.templateType = "Donor"
        }
        if (response.data.CustomerId) {
          this.isCustomer = true
          this.initValue = response.data.Customer
          this.selectedCustomer = response.data.Customer
        }
        this.interval = this.Subscription.intervalType[0].toUpperCase() + this.Subscription.intervalType.substr(1)
        console.log('this.interval', this.intervalDays)
        this.Days.map(day => {
          if (day.value == this.Subscription.intervalDays) {
            this.selectedDay = day
          }
        })
        this.Months.map(month => {
          if (month.value === this.Subscription.intervalMonth) {
            this.selectedMonth = month
          }
        })
        if (this.Subscription.recurringForever) {
          this.end = 'Forever'
        } else {
          this.endDateInit = this.Subscription.endDate
          if (this.Subscription.recurringCount) {
            this.end = 'Cycle'
            this.cycle = this.Subscription.recurringCount
          } else {
            this.end = 'By'
          }
        }

        return response;
      });
    },
    updateSubscription() {
      this.Subscription.cashCollect = this.cashCollect
      if (this.isCustomer) {
        this.Subscription.CustomerId = this.selectedCustomer.id
        this.Subscription.DefaultDonationCategoryId = this.selectedMerchant.id
        if (!this.Subscription.CustomerId) {
          this.selectCustomerError = [];
          this.selectCustomerError.push("Please Select Parent");
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: "Parent is not selected!",
            });
          return false;
        }
      } else {
        this.Subscription.DonorId = this.selectedCustomer.id
        if (!this.Subscription.DonorId) {
          this.selectCustomerError = [];
          this.selectCustomerError.push("Please Select Donor");
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: "Donor is not selected!",
            });
          return false;
        }
      }

      if (this.SubscriptionDetails) {
        this.Subscription.intervalType = this.interval.toLowerCase()
        this.Subscription.startingDate = this.startingDate
        this.Subscription.intervalDays = this.selectedDay.value
        if (this.selectedMonth) {
          this.Subscription.intervalMonth = this.selectedMonth.value
        }
        this.Subscription.endDate = this.endDate
        this.Subscription.recurringCount = this.cycle
        if (this.selectedCard) {
          this.Subscription.paymentMethodId = this.selectedCard.id
        }
        let saveSubscription = this.Subscription;
        if (this.getSelectedCampaign) {
          saveSubscription.CampaignId = this.getSelectedCampaign.id
        }

        saveSubscription.SubscriptionDetails = this.SubscriptionDetails;
        this.loadingUpdateBtn = true
        return subscriptionService
          .update(saveSubscription.id, saveSubscription)
          .then(() => {
            this.ResetSubscription();
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "success",
                title: "Subscription was updated!",
              });
            this.loadingUpdateBtn = false;
            this.$router.go(-1);
          })
          .catch((error) => {
            console.log("error on updating subscription", error);
            this.loadingUpdateBtn = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 6000,
              })
              .fire({
                icon: "error",
                title: error.data.message,
              });
          });
      }
    },
    addRow(val) {
      if (val) {
        this.AddSubscriptionDetail({
          ProductId: val.id,
          name: val.Bar.name,
          price: val.Bar.price,
          total: val.Bar.price * val.Bar.qty,
          qty: val.Bar.qty,
          cost: val.cost | 0,
          previousPrice: val.Bar.price,
        });
      }
    },
  },
};
</script>

<style scoped>
.v-expansion-panel-header__icon {
  margin-top: -10px;
}
</style>
